<!--
 * @Author: 孙照
 * @LastEditTime: 2023-10-10 14:19:27
 * @Description: 当前充电状况
 * @FilePath: \sheyang\src\module\chargingStats\leftContent\currentChargingState.vue
-->
<template>
  <div class="current-charging-state">
    <div style="width: 100%;" @click="handleNavGo">
      <pub-info-title :title="'当前充电状况'" />
    </div>
    <div class="charging_condition">
      <div class="apng-box">
        <img src="@/assets/images/apng/carCharingSmall.png" class="station-img" alt="">
      </div>
    </div>
    <div class="charging_condition_data">
      <div v-for="(item, index) in chargingConditionData" :key="index" class="item_content">
        <div class="item_content_box">
          <p :class="'fgc' + (index + 1)">{{ item.value }}</p>
          <img class="img-style" :src="item.url" alt="" />
          <span class="title">{{ item.title }}</span>
        </div>
        <div class="item_content_circle_box">
          <simgle-circle :info="item"></simgle-circle>
          <p>{{ item.baifenbi | toFixed }}%</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pubInfoTitle from '@/components/infoTitle/index.vue';
import simgleCircle from '@/components/simgleCircle/index.vue';
import { getChargeStatus } from '@/api/stationStatistics/index';

export default {
  name: 'currentCharging',
  components: {
    pubInfoTitle,
    simgleCircle,
  },
  filters: {
    // 保留两位小数
    toFixed (value) {
      return value.toFixed(0);
    },
  },
  data () {
    return {
      chargingConditionData: [
        {
          index: 0,
          title: '充电中',
          value: 0,
          url: require('@/assets/images/chargingStatistics/charging_icon.png'),
          baifenbi: 0,
        },
        {
          index: 1,
          title: '空闲',
          value: 0,
          url: require('@/assets/images/chargingStatistics/empty_icon.png'),
          baifenbi: 0,
        },
        {
          index: 2,
          title: '离线',
          value: 0,
          url: require('@/assets/images/chargingStatistics/offline_icon.png'),
          baifenbi: 0,
        },
        {
          index: 3,
          title: '故障',
          value: 0,
          url: require('@/assets/images/chargingStatistics/fault_icon.png'),
          baifenbi: 0,
        },
        {
          index: 4,
          title: '其他',
          value: 0,
          url: require('@/assets/images/chargingStatistics/other_icon.png'),
          baifenbi: 0,
        },
      ],
    };
  },
  mounted () {
    this.fecthChargeStatus();
  },
  methods: {
    fecthChargeStatus () {
      getChargeStatus().then((res) => {
        if (res.code === '200' && res.data) {
          this.chargingConditionData[0].value = res.data.adcCharging;
          this.chargingConditionData[0].baifenbi = res.data.adcChargingRatio * 100;
          this.chargingConditionData[1].value = res.data.adcFree;
          this.chargingConditionData[1].baifenbi = res.data.adcFreeRatio * 100;
          this.chargingConditionData[2].value = res.data.adcOffLine;
          this.chargingConditionData[2].baifenbi = res.data.adcOffLineRatio * 100;
          this.chargingConditionData[3].value = res.data.adcFault;
          this.chargingConditionData[3].baifenbi = res.data.adcFaultRatio * 100;
          this.chargingConditionData[4].value = res.data.rests;
          this.chargingConditionData[4].baifenbi = res.data.restsRatio * 100;
        }
      });
    },
    handleNavGo() {
      this.$emit('handleNavGo');
    }
  },
};
</script>

<style lang="less" scoped>
.current-charging-state {
  width: 100%;

  .charging_condition {
    width: 437px;
    height: 119px;
    margin: 20px 0 0 0;
  }

  .apng-box {
    width: 437px;
    height: 140px;
    position: relative;

    .station-img {
      width: 487px;
      height: 190px;
      position: absolute;
      top: -40px;
      left: -20px;
    }
  }

  .charging_condition_data {
    width: 437px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 19px;

    .item_content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .item_content_box {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 11px;

        p {
          height: 21px;
          line-height: 21px;
          font-size: 18px;
          text-align: center;
          animation: bounce-down 3.5s linear infinite;
        }

        p.fgc1 {
          color: #12fbf7;
        }

        p.fgc2 {
          color: #ffab13;
        }

        p.fgc3 {
          color: #e2e2e2;
        }

        p.fgc4 {
          color: #ff4013;
        }

        p.fgc5 {
          color: #13a1ff;
        }

        .img-style {
          width: 63px;
          height: 60px;
        }

        .title {
          font-size: 12px;
          color: #ffffff;
          margin-top: 4px;
        }
      }

      .item_content_circle_box {
        width: 76px;
        height: 33px;
        padding: 6px 10px;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        justify-content: space-between;
        .backgroundImage('@/assets/images/chargingStatistics/charging_condition_box.png');

        p {
          color: #ffffff;
          font-size: 12px;
        }
      }
    }
  }

  @keyframes bounce-down {
    0% {
      -webkit-transform: translateY(15px);
    }

    50% {
      -webkit-transform: translateY(25px);
    }

    100% {
      -webkit-transform: translateY(15px);
    }
  }
}</style>
